module.exports = __webpack_public_path__ + "img/y-172.68a6afce.png";